/**
 * Model for handling TbEPayment data transformations
 */
import useBuyStore from "../store/BuyStore";

const TbEPaymentsMapper = {
  get() {
    const paymentOptionsResponse = useBuyStore
      .getState()
      .getObject("paymentOptionsResponse");
    const serviceCharge =
      paymentOptionsResponse?.paymentOptions?.[0]?.serviceCharge;
    const monthlyOption = paymentOptionsResponse?.paymentOptions?.[0];
    const annualOption = paymentOptionsResponse?.paymentOptions?.[1];
    return {
      quoteBreakdown: paymentOptionsResponse?.quoteBreakdown ?? null,
      paymentOptionsMonthly: monthlyOption
        ? {
            installmentAmount: monthlyOption.installmentAmount,
            deposit: monthlyOption.deposit,
            installments: monthlyOption.instalments,
            paymentOptionId: monthlyOption.paymentOptionId,
          }
        : null,
      paymentOptionsAnnually: annualOption
        ? {
            totalAmountToPayByCustomer: annualOption.totalAmountToPayByCustomer,
            paymentOptionId: annualOption.paymentOptionId,
          }
        : null,
      financeAvailable:
        paymentOptionsResponse?.paymentOptions?.[0]
          ?.financeAvailableToCustomer ?? false,
      selectedOption: null,
      serviceCharge: serviceCharge,
    };
  },
};

export default TbEPaymentsMapper;
